<template>
  <ModalNuevo class="filters-modal"
              :open="props.open"
              data-test-id="filters-modal"
              @close="emit('close')"
  >
    <div class="filters-modal__content">
      <FilterAccordion class="filters-modal__accordion"
                       filter-type="sorting"
                       data-test-id="accordion-sorting-mobile"
      >
        {{ t('terms.sorting') }}
      </FilterAccordion>

      <FilterAccordion v-if="onSearchPage"
                       class="filters-modal__accordion"
                       filter-type="establishment-type"
                       data-test-id="accordion-establishment-types-mobile"
      >
        {{ t('filters.establishment_type') }}
      </FilterAccordion>

      <FilterAccordion class="filters-modal__accordion"
                       filter-type="categories"
                       data-test-id="accordion-categories-mobile"
      >
        {{ t('categories.categories') }}
      </FilterAccordion>
    </div>

    <template #modal-bottom>
      <div class="filters-modal__bottom">
        <Button @click="emit('close')">
          {{ buttonText }}
        </Button>
      </div>
    </template>
  </ModalNuevo>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Button from '@/components/partials/Buttons/Button/Button.vue'
import ModalNuevo from '@/components/Modals/ModalNuevo/ModalNuevo.vue'
import FilterAccordion from '@/components/partials/FilterAccordion.vue'
import useMarketplaceOverviewType from '../../composables/useMarketplaceOverviewType'
import OverviewTypes from '@/config/OverviewTypes'
import { useMarketplaceStore } from "@/stores/ssr/useMarketplaceStore"

const marketplaceStore = useMarketplaceStore()

const props = defineProps<{
  open: boolean
}>()

const emit = defineEmits([ 'close' ])

const { t } = useI18n()

const { overviewType } = useMarketplaceOverviewType()

const onSearchPage = computed(() => overviewType.value === OverviewTypes.Search)

const buttonText = computed<string>(() => t('marketplace_search.show_amount_of_results', {
  amountOfResults: marketplaceStore.items?.length ?? 0,
}))
</script>

<style lang="scss" scoped>
.filters-modal {
  &__accordion {
    margin: 2rem 0 0 0;

    &:deep(.accordion__content) {
      padding-top: 1rem;
    }
  }

  &__bottom {
    display: flex;
    justify-content: center;
    width:   100%;
  }
}
</style>
